// Pages that use multiple `collapsible-content` sections (e.g. an FAQ page
// grouped into several categories) each auto-generate their own FAQPage
// JSON-LD block (see collapsible-content.liquid). Google's guidance is to
// have one consolidated FAQPage per page rather than several, so this merges
// them into a single block after the page loads. No-op if there's 0 or 1.
document.addEventListener("DOMContentLoaded", function () {
  var scripts = document.querySelectorAll('script[type="application/ld+json"]');
  var faqScripts = [];
  var parsed = [];

  scripts.forEach(function (script) {
    var data;
    try {
      data = JSON.parse(script.textContent);
    } catch (e) {
      return;
    }
    if (data && data["@type"] === "FAQPage" && Array.isArray(data.mainEntity)) {
      faqScripts.push(script);
      parsed.push(data);
    }
  });

  if (faqScripts.length < 2) return;

  var merged = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [],
  };
  parsed.forEach(function (data) {
    merged.mainEntity = merged.mainEntity.concat(data.mainEntity);
  });

  faqScripts[0].textContent = JSON.stringify(merged);
  for (var i = 1; i < faqScripts.length; i++) {
    faqScripts[i].remove();
  }
});
